import type { Countable } from '@/types/general';

export const percentFormatter = new Intl.NumberFormat(undefined, {
    style: 'percent',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
});

export const numberFormatter = new Intl.NumberFormat(undefined, {
    // Compact notation not desired
    notation: 'standard',
});

export const pluralize = (count: number, { singular, plural }: Countable) => {
    return Math.abs(count) === 1 ? singular : plural;
};

export const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1);

export const unCamelize = (str: string) => {
    // ? Matches all spaces between characters that
    // ? are followed by a capital letter, but not
    // ? preceded by the start of the string.
    const regex = /(?=(?<!=^)[A-Z])/g;

    return capitalize(str).replace(regex, ' ');
};
